import { ErrorStateScheduleEnum } from '../../error-state-schedule.enum';

export enum PanelSettingsProductsEditDetailsResolverErrorStateEnum {
    GetProductFailed = ErrorStateScheduleEnum.PanelSettingProductsEditDetailsResolverStatesStartIndex,
    GetProductNoData,
    GetSymbolsFailed
}
